import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs/operators';

@Component({
  selector: 'bom-digital-signering-kvittering',
  templateUrl: './digital-signering-kvittering.component.html',
  styleUrls: ['./digital-signering-kvittering.component.scss'],
})
export class DigitalSigneringKvitteringComponent implements OnInit, OnDestroy {
  errorMessage: string;
  signering: string;
  alertType: string;
  descriptionKey: string;
  header: string;

  constructor(private route: ActivatedRoute, private router: Router) {}

  ngOnInit() {
    this.route.queryParams.pipe(take(1)).subscribe(params => {
      if (params.error) {
        this.errorMessage = params.error;
      } else if (params.pseudonym) {
        this.alertType = 'warning';
        this.descriptionKey = 'DigitalSigneringPseudonymKvittering';
        this.header = 'Digital signering afvist';
      } else if (params.eksternFejl) {
        this.alertType = 'warning';
        this.descriptionKey = 'DigitalSigneringEksternFejlKvittering';
        this.header = 'Digital signering afvist';
      } else if (params.errorKey) {
        this.alertType = 'error';
        this.descriptionKey = params.errorKey;
        this.header = 'Digital signering fejlet';
      } else {
        this.alertType = 'successAlert';
        this.descriptionKey = 'DigitalSigneringKvitteringSuccess';
        this.header = 'Kvittering på digital signering';
      }
    });

    this.signering = sessionStorage.getItem('signering');
  }

  redirect() {
    this.router.navigateByUrl(this.signering);
  }

  ngOnDestroy() {
    sessionStorage.removeItem('signering');
  }
}
